import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsertLink = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(-4)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 24,
			rx: 2
		}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 0L24 0 24 24 0 24z",
			transform: "translate(4)"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#475464",
			fillRule: "nonzero",
			d: "M6.272 17.728c-1.209-1.21-1.209-3.175 0-4.384l2.829-2.829-1.344-1.343L4.93 12c-1.952 1.952-1.952 5.12 0 7.071 1.952 1.952 5.12 1.952 7.071 0l2.828-2.828-1.343-1.344-2.829 2.829c-1.209 1.209-3.174 1.209-4.384 0zm3.607-2.192l5.657-5.657-1.415-1.415-5.657 5.657 1.415 1.415zM12 4.929L9.172 7.757l1.343 1.344 2.829-2.829c1.209-1.209 3.174-1.209 4.384 0 1.209 1.21 1.209 3.175 0 4.384l-2.829 2.829 1.344 1.343L19.07 12c1.952-1.952 1.952-5.12 0-7.071-1.952-1.952-5.12-1.952-7.071 0z",
			transform: "translate(4)"
		})] })]
	})
});
export default SvgInsertLink;
